import { render, staticRenderFns } from "./TaskCompletedDate.vue?vue&type=template&id=7e87c54c&scoped=true&"
import script from "./TaskCompletedDate.vue?vue&type=script&lang=js&"
export * from "./TaskCompletedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e87c54c",
  null
  
)

export default component.exports